import Skeleton from "react-loading-skeleton";

import { cn } from "@/lib/helpers/cn";

import { PageControl } from "./PageControl";

const NOOP = () => {};
const TILE_COUNT = 7;

type PaginationSkeletonProps = {
  className?: string;
};

export function PaginationSkeleton({ className }: PaginationSkeletonProps) {
  return (
    <nav aria-label="Pagination" className={cn("tw:flex tw:items-center tw:gap-2", className)}>
      <PageControl direction="previous" isDisabled onPress={NOOP} />
      {Array.from({ length: TILE_COUNT }, (_, i) => (
        <Skeleton borderRadius={8} containerClassName="tw:flex" height={32} key={i} width={32} />
      ))}
      <PageControl direction="next" isDisabled onPress={NOOP} />
    </nav>
  );
}
